(function LivePlannerHistory($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload(['/LivePlanner/history', '/LivePlanner/historyShareSession'], function onload()
		{
			$('.lp-session').click(function _showSummary(e) {
				var lp_session_id = $(this).data('lp-session'),
					$modal        = $('#modalWindow');

				e.preventDefault();

				$modal.find('.modal-body').html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;Loading LivePlanner summary...');
				$modal.find('.modal-title').text('LivePlanner Summary Preview');
				$modal.modal('show');

				Adzuki.Ajax.get('/LivePlanner/summary/' + lp_session_id)
				.then(function showDetails(response) {
					let content = '<iframe src="' + response + '" style="width: 100%; height: 800px;"></iframe>';
					$modal.find('.modal-body').html(content);
				});
			});
			
			
			// Export All Trips button clicked
			$('.all_trip_export_button').click(function handleAllTripsExport(e) {
				e.preventDefault();
				let post_data = {
					session_id: $(this).data('lp-session'),
				};
				Adzuki.StatusMessage('Success', 'An email with the requested PDF has been sent to ' + $('#current_client_email_input').val() + '.');
				Adzuki.Ajax.post( Adzuki.base_uri + '/LivePlanner/historySendPdf/', post_data);
			});

			
		}, false);
	});
}(jQuery, window.Adzuki || {}));